import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get, Post } from "../api/api";
import { Config } from "../api/config";
import {
  USER_LOGIN_DATA,
  WOH_AM_I_DATA,
  changePasswordURL,
  whoamiUrl,
} from "../api/url";
import {
  getLocalStorageItem,
  getWhoAmIToken,
  setLocalStorageItem,
} from "../utils/storageHelper";
import { showLoader, showNotification } from "./commonSlice";

export interface IAuthorization {
  whoamiData: any;
  loginData: any;
  identity: any;
  getUserByIdentityId: any;
  isSubmit: boolean;
  isBasicSubmit: boolean;
  isIndustrySubmit: boolean;
  isCompanySubmit: boolean;
  isLegalSubmit: boolean;
  isTaxSubmit: boolean;
  status: "idle" | "loading" | "failed";
}

const initialState: IAuthorization = {
  whoamiData: null,
  identity: null,
  loginData: getLocalStorageItem(USER_LOGIN_DATA),
  getUserByIdentityId: null,
  isSubmit: false,
  isBasicSubmit: false,
  isIndustrySubmit: false,
  isCompanySubmit: false,
  isLegalSubmit: false,
  isTaxSubmit: false,
  status: "idle",
};
export const whoAmIAPI = createAsyncThunk("whoami", async () => {
  let headers: any = {
    "Client-Id": Config.ClientID,
    "Client-Secret": Config.ClientSecret,
    Subscription: Config.Subscription,
  };
  const response = await Get(whoamiUrl, { headers: headers });
  setLocalStorageItem(WOH_AM_I_DATA, response);
  // setLocalStorageItem("Subscription", Config.Subscription);
  return response;
});

export const loginAPI = createAsyncThunk(
  "login",
  async (request: any, { dispatch }) => {
    const whoAMIData: any = getWhoAmIToken();
    dispatch(showLoader(true));

    request.ApplicationKey = Config.ApplicationKey;
    request.ApplicationSecret = Config.ApplicationSecret;

    const response: any = await Post(
      `${Config.baseURL}Identity/SignInWithUsernameAndPassword`,
      request,
      {
        headers: {
          Authorization: `Bearer ${whoAMIData}`,
          subscription: Config.Subscription,
        },
        withCredentials: true,
      }
    );
    if (response?.statusCode === 200) {
      setLocalStorageItem(USER_LOGIN_DATA, response);
      dispatch(showLoader(false));
      dispatch(
        showNotification({
          isOpen: true,
          message: "Logged in successfully",
          type: "success",
        })
      );
      return response;
    } else {
      dispatch(showLoader(false));
      dispatch(
        showNotification({
          isOpen: true,
          message: response?.data?.message,
          type: "error",
        })
      );
      return response;
    }
  }
);

export const changePasswordAPI = createAsyncThunk(
  "changePassword",
  async (request: any, { dispatch }) => {
    const response: any = await Post(changePasswordURL, request);

    if (response?.statusCode === 200 || response?.success) {
      dispatch(
        showNotification({
          isOpen: true,
          message: response?.data,
          type: "success",
        })
      );
      return response;
    } else {
      dispatch(
        showNotification({
          isOpen: true,
          message: response?.data,
          type: "error",
        })
      );
      return response;
    }
  }
);

export const getUserByIdentityIdAPI = createAsyncThunk(
  "userByIdentityId",
  async (IdentityId: any) => {
    const response = await Get(`${Config.baseURL}Identity/${IdentityId}/Get`);
    return response;
  }
);

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsSubmitData: (state, action: PayloadAction<any>) => {
      return { ...state, isSubmit: action.payload };
    },
    setIsBasicData: (state, action: PayloadAction<any>) => {
      return { ...state, isBasicSubmit: action.payload };
    },
    setIsIndustryData: (state, action: PayloadAction<any>) => {
      return { ...state, isIndustrySubmit: action.payload };
    },
    setIsCompanyData: (state, action: PayloadAction<any>) => {
      return { ...state, isCompanySubmit: action.payload };
    },
    setIsLegalData: (state, action: PayloadAction<any>) => {
      return { ...state, isLegalSubmit: action.payload };
    },
    setIsTaxData: (state, action: PayloadAction<any>) => {
      return { ...state, isTaxSubmit: action.payload };
    },
    logout: (state) => {
      localStorage.removeItem(WOH_AM_I_DATA);
      localStorage.removeItem(USER_LOGIN_DATA);
      localStorage.removeItem("Subscription");
      state.loginData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(whoAmIAPI.pending, (state) => {
        state.status = "loading";
      })
      .addCase(whoAmIAPI.fulfilled, (state, action) => {
        state.status = "idle";
        state.whoamiData = action.payload;
      })
      .addCase(whoAmIAPI.rejected, (state) => {
        state.status = "failed";
        state.whoamiData = null;
      })
      .addCase(loginAPI.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loginAPI.fulfilled, (state, action) => {
        state.status = "idle";
        state.loginData = action.payload;
      })
      .addCase(loginAPI.rejected, (state) => {
        state.status = "failed";
        state.loginData = null;
      })
      .addCase(getUserByIdentityIdAPI.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getUserByIdentityIdAPI.fulfilled, (state, action) => {
        state.status = "idle";
        state.getUserByIdentityId = action.payload;
      })
      .addCase(getUserByIdentityIdAPI.rejected, (state) => {
        state.status = "failed";
        state.getUserByIdentityId = null;
      });
  },
});

export const {
  setIsSubmitData,
  setIsBasicData,
  setIsCompanyData,
  setIsIndustryData,
  setIsLegalData,
  setIsTaxData,
  logout
} = authSlice.actions;

export const authReducer = authSlice.reducer;

export default authReducer;
